// used in the database instance detail report which lists all the databases / tablespaces available on an instance.

import {cleanNumberFormatter, percentageBarFormatter} from "../../gridFormatters";

export const databaseInstanceDetailRefs = [
    {
        "field": "database_server_ip",
        "headerName": "Server IP Address",
        "hidden": true
    },
    {
        "field": "instance",
        "headerName": "Instance Name",
        "hidden": true
    },
    {
        "field": "database_name",
        "headerName": "Database Name"
    },
    {
        "field": "tablespace_name",
        "headerName": "Tablespace Name"
    },
    {
        "field": "tables_count",
        "headerName": "Total Tables",
        cellRenderer: cleanNumberFormatter,
        "type": "numericColumn"
    },
    {
        "field": "total_objects",
        "headerName": "Total Objects",
        cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",
    },
    {
        "field": "pct_used",
        "headerName": "% Used",
        cellRenderer: percentageBarFormatter,
        "type": "numericColumn",
    },
    {
        "field": "used",
        "headerName": "Used",
        cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",
    },
    {
        "field": "allocated",
        "headerName": "Allocated",
        cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",
    },
    {
        "field": "free",
        "headerName": "Free",
        cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",
    },
    {
        "field": "increment",
        "headerName": "Increment",
        cellRenderer: cleanNumberFormatter,
        "type": "numericColumn",
    }
];